export const DEFAULT_INTERFACE_PREFERENCES = Object.freeze({
  celebrationModals: true,
  toastNotifications: true,
  friendActivityNotifications: true,
  legendaryHighlights: true,
  notificationBadges: true,
  motionEffects: true
});

export const INTERFACE_PREFERENCE_KEYS = Object.freeze(
  Object.keys(DEFAULT_INTERFACE_PREFERENCES) as (keyof InterfacePreferences)[]
);

export type InterfacePreferences = {
  -readonly [Key in keyof typeof DEFAULT_INTERFACE_PREFERENCES]: boolean;
};

export const normalizeInterfacePreferences = (value?: unknown): InterfacePreferences => {
  const source = value && typeof value === "object" ? value as Record<string, unknown> : {};

  return INTERFACE_PREFERENCE_KEYS.reduce((preferences, key) => {
    const candidate = source[key];
    preferences[key] = typeof candidate === "boolean"
      ? candidate
      : DEFAULT_INTERFACE_PREFERENCES[key];
    return preferences;
  }, {} as InterfacePreferences);
};
